import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Cpu, FileText, Bell, Settings } from 'lucide-react'
import { cn } from '../../lib/utils'
import { useNotificationStore } from '../../stores/notificationStore'

const tabs = [
  { to: '/', icon: LayoutDashboard, label: 'Home', end: true },
  { to: '/devices', icon: Cpu, label: 'Devices' },
  { to: '/proposals', icon: FileText, label: 'Proposals' },
  { to: '/alerts', icon: Bell, label: 'Alerts' },
  { to: '/settings', icon: Settings, label: 'Settings' },
]

export default function BottomNav() {
  const unreadCount = useNotificationStore((s) => s.unreadCount())

  return (
    <nav aria-label="Mobile navigation" className="fixed bottom-0 left-0 right-0 z-50 bg-bg-sidebar border-t border-border md:hidden">
      <div className="flex items-center justify-around h-14">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            aria-label={tab.label}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-0.5 py-1 px-3 min-w-[56px] relative',
                isActive ? 'text-accent' : 'text-text-secondary',
              )
            }
          >
            <span className="relative">
              <tab.icon size={20} />
              {tab.label === 'Alerts' && unreadCount > 0 && (
                <span className="absolute -top-1 -right-1.5 min-w-[16px] h-4 bg-accent text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </span>
            <span className="text-[10px]">{tab.label}</span>
          </NavLink>
        ))}
      </div>
      {/* Safe area inset */}
      <div className="h-[env(safe-area-inset-bottom)]" />
    </nav>
  )
}
